import appConfig from 'appConfig';

export default class LTService {
  constructor() {
    this.configs = appConfig.getLTConfig();
  }

  getConfig(id) {
    if (id) {
      return this.configs?.integrations?.[id] || {};
    } else {
      return this.configs;
    }
  }

  // Launch Parameter details for JOURNALs : https://pearson.atlassian.net/wiki/spaces/FIT/pages/74643678/Bronte+Journal+Integration+over+FIT
  // eslint-disable-next-line no-unused-vars
  async getLaunch(_id, _type = '') {
    return {
      tool_consumer: 'BRONTE',
      mode: 'preview',
    };
  }

  static build(args) {
    return new LTService(args);
  }
}